import { toast } from "react-toastify";
import { startPettyWork } from "features/PettyWorks/services/PettyWorkService";

export function pettyWorkWorkflowErrorMessage(err: unknown): string {
  const ax = err as {
    response?: { data?: { message?: string } };
    message?: string;
  };
  return ax.response?.data?.message || ax.message || "Request failed";
}

export async function runPettyWorkStart(id: number): Promise<boolean> {
  try {
    const res = await startPettyWork(id);
    if (res.success) {
      toast.success(res.message ?? "Petty work started");
      return true;
    }
    toast.error(res.message ?? "Could not start petty work");
    return false;
  } catch (e) {
    toast.error(pettyWorkWorkflowErrorMessage(e));
    return false;
  }
}
